var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "_component-serve" }, [
    _vm._m(0),
    _c("p", { staticClass: "text3 color-gray-2 mt-10 t-ct" }, [
      _vm._v("打开微信扫一扫")
    ]),
    _c("p", { staticClass: "text1 bold text-1 t-ct color-black-1" }, [
      _vm._v("微信公众号")
    ]),
    _c("div", {
      staticClass: "close-wrap",
      on: {
        click: function($event) {
          return _vm.$emit("close")
        }
      }
    })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "qr-wrap img-wrap" }, [
      _c("img", {
        attrs: {
          src: "//hsylc.oss-cn-hangzhou.aliyuncs.com/2024/side-helper/qr-2.png",
          alt: ""
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }